import { AnimatedSection } from "@/components/AnimatedSection";

const stats = [
  { value: "4.4★", label: "Google Rating", sub: "Verified" },
  { value: "116+", label: "Local Reviews", sub: "And growing" },
  { value: "All Makes", label: "Cars & Vans", sub: "Inc. premium" },
  { value: "One Roof", label: "Every Service", sub: "MOT to bodywork" },
];

export function ProofStrip() {
  return (
    <AnimatedSection>
      <section className="py-12 md:py-16 bg-card border-y border-border">
        <div className="mx-auto max-w-6xl px-4 md:px-6">
          <div className="text-center mb-8 md:mb-10">
            <p className="eyebrow-muted">By the numbers</p>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-8 md:gap-y-0">
            {stats.map((s, i) => (
              <div key={s.label} className="relative text-center px-3">
                <p className="text-4xl md:text-5xl font-extrabold text-foreground tracking-tighter">
                  {s.value}
                </p>
                <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.18em] text-foreground/80">
                  {s.label}
                </p>
                <p className="mt-1 text-[11px] text-muted-foreground">{s.sub}</p>
                {i < stats.length - 1 && (
                  <div className="hidden md:block absolute right-0 top-1/2 -translate-y-1/2 h-14 w-px bg-border" />
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
    </AnimatedSection>
  );
}
